import React, { useState, useEffect } from "react";
import { encode } from "blurhash";
import { Blurhash } from "react-blurhash";

const getImageBlurhash = async (imageUrl, width, height) => {
  const img = new Image();
  img.crossOrigin = "Anonymous";
  img.src = imageUrl; // Set the source after the onload handler to trigger loading
  return new Promise((resolve) => {
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);

      const imageData = ctx.getImageData(0, 0, width, height);
      const blurhash = encode(
        imageData.data,
        imageData.width,
        imageData.height,
        4,
        3
      );
      resolve(blurhash);
    };
  });
};

const getImage = async (imageUrl) => {
  const img = new Image();
  img.crossOrigin = "Anonymous";
  img.src = imageUrl; // Set the source after the onload handler to trigger loading
  return new Promise((resolve) => {
    img.onload = () => {
      resolve("downloaded");
    };
  });
};

const BlurryImage = ({
  hash = null,
  imageUrl,
  className,
  alt,
  width,
  height,
}) => {
  const [blurhash, setBlurhash] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (hash === null) {
      getImageBlurhash(imageUrl, 32, 32).then((hash) => {
        setBlurhash(hash);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [imageUrl, width, height]);

  return (
    <>
      {loading ? (
        <Blurhash
          hash={blurhash || (hash ?? "L4EpKK00000000%O_NayH;9d--4n")}
          className={className}
          width={100}
          height={100}
        />
      ) : (
        <img src={imageUrl} alt={alt} className={className} />
      )}
    </>
  );
};

export default BlurryImage;
